import React from 'react';
import { Form } from 'antd';
import SettingsProductDrawerForm from '../../Settings/SettingsProductDrawerForm';

interface EditProductFormViewProps {
  onDone: (created?: { id: string; name: string }) => void;
}

/** The edit drawer's "Add new product" view, mounted only while open so each product starts blank; `onDone` gets the product it created, if any. */
const EditProductFormView: React.FC<EditProductFormViewProps> = ({
  onDone,
}) => {
  const [form] = Form.useForm();
  return (
    <SettingsProductDrawerForm
      form={form}
      id={null}
      showBackButton
      handleCloseDrawer={() => onDone()}
      handleFetchAllProduct={onDone}
    />
  );
};

export default EditProductFormView;
